externalId:
    en: 'External ID'
    es: 'Num. externo'
    fr: 'ID externe'
    pt: 'ID Externo'
    ru: 'Внешний идентификатор'
vehicleType:
    en: 'Vehicle type'
    es: 'Tipo de vehículo'
    fr: 'Type de véhicule'
    pt: 'Tipo de veículo'
    ru: 'Тип машины'
types:
    en: 'Supported vehicle requirements'
    es: 'Requerimientos soportados por el vehículo'
    fr: 'Propriétés véhicule supportées'
    pt: 'Requisitos do veículo suportados'
    ru: 'Поддерживаемые требования к ТС'
manufacturerInfo:
    en: 'Manufacturer Info'
    es: 'Info. del fabricante'
    fr: 'Informations fabricant'
    pt: 'Informação fabricante'
    ru: Производитель
VIN:
    en: VIN or Registration №
    es: VIN o Número de registro
    fr: VIN ou Numéro d'immatriculation
    pt: VIN ou Número de registo
    ru: 'Заводской номер'
priceForOneMile:
    en: 'Cost per {0}'
    es: 'Coste por {0}'
    fr: 'Coût au {0}'
    pt: 'Custo por {0}'
    ru: 'Стоимость за {0}'
vehicleActivationCost:
    en: 'Vehicle activation cost'
    es: 'Coste activación del vehículo'
    fr: "Coût d'activation du véhicule"
    pt: 'Custo ativação veículo'
    ru: 'Цена машины'
costPerOrder:
    en: 'Cost per order'
    es: 'Coste por pedido'
    fr: 'Coût par commande'
    pt: 'Custo por ordem'
    ru: 'Цена заказа'
runDistanceLimit:
    en: 'Run distance limit'
    es: 'Límite de distancia de la ruta'
    pt: 'Limite de distância de rota'
    ru: 'Максимальная протяженность рейса'
    fr: 'Limite de distance de course'
maxSpeed:
    en: 'Max speed'
    es: 'Velocidad Max.'
    fr: 'Vitesse maximum'
    pt: 'Velocidade máxima'
    ru: 'Максимальная скорость'
speedCorrectionFactor:
    en: 'Driving time correction factor'
    es: 'Factor de corrección del tiempo de conducción'
    fr: 'Facteur de correction de temps de conduite'
    pt: 'Fator de correção do tempo de condução'
    ru: 'Корректирующий коэффициент времени вождения'
driverHasVehicle:
    en:
        'You have selected a driver with a vehicle already assigned to him/her. What would you like to do with this
        assigned vehicle?'
    es: 'Has seleccionado un conductor con un vehículo ya asignado a él/ella'
    fr:
        'Vous avez sélectionné un chauffeur à qui un véhicule est déjà assigné. Que souhaitez-vous faire avec ce véhicule assigné?'
    pt: 'Selecionou um condutor(a) que já tem um veículo atribuído. O que pretende fazer com o veículo já atribuído?'
    ru: 'Вы выбрали водителя, с назначенной на него машиной. Что вы хотите сделать с машиной?'
swapDrivers:
    en: 'Swap drivers'
    es: 'Intercambiar conductores'
    fr: 'Échanger les chauffeurs'
    pt: 'Trocar condutores'
    ru: 'Сменить водителей'
unallocatedDriver:
    en: 'Unallocate driver from that vehicle'
    es: 'Desasignar conductor desde ese vehículo'
    fr: 'Désaffecter le conducteur de ce véhicule'
    pt: 'Anular atribuição do condutor ao veículo'
    ru: 'Освободить водителя от той машины'
speedCorrectionFactorInfo:
    en:
        'Driving time correction factor is used as an index for driving times of a specific vehicle. This index is used
        to slow such vehicle down or speed it up. For example, the index of 1.5 increases the driving time by 50%.'
    es:
        'El factor de corrección del tiempo de conducción se usa como un índice para los tiempos de conducción de un
        vehículo especifico. Este índice se usa retrasar tal vehículo o acelerarlo. Por ejemplo, el índice de 1.5
        incrementa el tiempo de conducción un 50%'
    fr:
        'Driving time correction factor is used as an index for driving times of a specific vehicle. This index is used
        to slow such vehicle down or speed it up. For example, the index of 1.5 increases the driving time by 50%.'
    pt:
        'O fator de correção do tempo de condução é usado como um índice para o tempo de condução de um veículo
        especifíco; serve para corrigir a velocidade em função das condições. Se o indice for por exemplo 1.5, aumenta o
        tempo de condução 50%'
    ru:
        'Коэффицент, на который будет поправленно время вождения данного автомобиля. Используется для того что бы
        замедлить или ускорить его. 1.5 означает, что все время вождения увеличится на 50% от оригинального.'
RESOURCE_HAS_SCHEDULE:
    en:
        'The selected vehicle has orders allocated for the selected day. If you proceed, the orders will be unallocated.
        Would you like to proceed?'
    ru: 'На выбранную машину запланированы заказы. Эти заказы будут отпланированы. Продолжить?'
    es:
        'El vehículo seleccionado tiene pedidos asignados para el día seleccionado. Si continúa, los pedidos se
        desasignarán. ¿Le gustaría continuar?'
    pt:
        'O veículo selecionado tem pedidos atribuídos para o dia selecionado. Se prosseguir, a atribuição dos pedidos
        será cancelada. Deseja continuar?'
RESOURCE_HAS_SCHEDULE_WITH_DATES:
    en:
        'The selected vehicle has orders allocated for the following days: {0}. If you proceed, the orders will be
        unallocated. Would you like to proceed? '
    ru: 'На выбранную машину запланированы заказы на следующие даты: {0}. Эти заказы будут отпланированы. Продолжить?'
    es:
        'El vehículo seleccionado tiene pedidos asignados para los días siguientes: {0}. Si continúa, los pedidos serán
        desasignados. ¿Le gustaría continuar?'
    pt:
        'O veículo selecionado tem pedidos atribuídos para os dias seguintes: {0}. Se prosseguir, a atribuição dos
        pedidos será cancelada. Deseja continuar?'
vehicleChecks:
    en: Start of day vehicle check
    ru: Проверка транспортного средства в начале дня
    es: Inicio del día revisión de vehículo
    fr: Début de la journée vérifications du véhicule
additionalVehicleChecks:
    en: Additional vehicle checks
    ru: Дополнительная проверка автомобиля
    es: Adicional revisión de vehículo
    fr: Supplémentaire vérifications du véhicule
createDriverLabel:
    en: 'Do you want to create a driver for this vehicle?'
    es: '¿Quieres cear un conductor para este vehículo?'
    fr: 'Voulez-vous créer un chauffeur pour ce véhicule ?'
    pt: 'Deseja criar um condutor para este veículo?'
    ru: 'Создать водителя для этой машины?'
addingNewVehicle:
    en: 'Adding new vehicle'
    es: 'Añadiendo nuevo vehículo'
    fr: 'Ajout d’un nouveau véhicule'
    pt: 'Adicionando novo veículo'
    ru: 'Добавление новой машины'
constraints:
    en: 'Constraints'
    es: 'Restricciones'
    fr: 'Contraintes'
    pt: 'Restrições'
    ru: 'Ограничения'
basics: 
    en: 'Basics'
    es: 'Básicos'
    fr: 'Basiques'
    pt: 'Básicos'
    ru: 'Основное'
gps: 
    en: 'GPS'
    es: 'GPS'
    fr: 'GPS'
    pt: 'GPS'
    ru: 'GPS'
addComment: 
    en: 'Add a comment'
    es: 'Añadir un comentario'
    fr: 'Ajouter un commentaire'
    pt: 'Adicionar um comentário'
    ru: 'Добавить комментарий'
cloneVehicle:
    en: 'Clone vehicle'
    es: 'Clonar vehículo'
    fr: 'Cloner véhicule'
    pt: 'Clonar veículo'
    ru: 'Клонировать машину'
offDuty:
    en: 'Off-duty'
    es: 'Fuera de servicio'
    fr: 'Hors service'
    pt: 'Fora de serviço'
    ru: 'Вне смены'
